import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Paper,
    Box,
    Stack
} from "@mui/material";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import BackHandIcon from "@mui/icons-material/BackHand";

interface TemplateCreateDialogProps {
    open: boolean;
    onClose: () => void;
    onManual: () => void;
    onWizard: (file: File) => void;
}

const TemplateCreateDialog: React.FC<TemplateCreateDialogProps> = ({
    open,
    onClose,
    onManual,
    onWizard
}) => {
    const fileInputRef = React.useRef<HTMLInputElement>(null);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            onWizard(file);
            e.target.value = ""; // reset for next upload
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ textAlign: "center" }}>
                Kies een manier om een template te maken
            </DialogTitle>
            <DialogContent>
                <Stack direction={{ xs: "column", sm: "row" }} spacing={3}>
                    <Box flex={1}>
                        <Paper variant="outlined" sx={{ p: 2, textAlign: "center" }}>
                            <AutoFixHighIcon color="primary" sx={{ fontSize: 40, mb: 1 }} />
                            <Typography variant="h6" gutterBottom>
                                Template Wizard
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                Onze AI maakt een eerste opzet voor je, aan de hand van een anoniem voorbeeldverslag.
                                <br /> <br />
                                
                                Belangrijk: Controleer de juistheid en anonimiteit van het template. Er moet geen informatie in staan die  direct of indirect herleidbaar is naar een specifiek persoon. <br /> <br />

                                We ondersteunen .docx (word), .pdf en .txt (tekst) bestanden. <br />
                            </Typography>
                            <Box mt={2}>
                                <Button
                                    variant="contained"
                                    component="label"
                                    fullWidth
                                >
                                    Upload voorbeeld
                                    <input
                                        type="file"
                                        accept=".pdf,.docx,.txt"
                                        hidden
                                        ref={fileInputRef}
                                        onChange={handleFileChange}
                                    />
                                </Button>
                            </Box>
                        </Paper>
                    </Box>
                    <Box flex={1}>
                        <Paper variant="outlined" sx={{ p: 2, textAlign: "center" }}>
                            <BackHandIcon color="primary" sx={{ fontSize: 40, mb: 1 }} />
                            <Typography variant="h6" gutterBottom>
                                Handmatig
                            </Typography>
                            <Typography variant="body2" gutterBottom>
                                Je kunt ook beginnen met een leeg template. <br/><br/>
                                Kies deze optie als je geen goed voorbeeld document hebt, of omdat je om een andere reden geen AI wil gebruiken. 
                                <br /> <br />
                                Tip: Probeer zoveel mogelijk informatie te geven over de inhoud, structuur en schrijfstijl van het verslag.
                            </Typography>
                            <Box mt={2}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    onClick={onManual}
                                >
                                    Zelf maken
                                </Button>
                            </Box>
                        </Paper>
                    </Box>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Annuleren</Button>
            </DialogActions>
        </Dialog>
    );
};

export default TemplateCreateDialog;
